export default "__VITE_ASSET__681635fd__"